export const SCHOLARSHIP_TEST_CARD_VIEWED = 'Scholarship Test - Card Viewed';
export const SCHOLARSHIP_TEST_CLICKED = 'Scholarship Test - Clicked';
export const SCHOLARSHIP_TEST_LEADERBOARD_VIEWED =
  'Scholarship Test - Leaderboard Viewed';
